module.exports = __webpack_public_path__ + "img/icon.c50293a.png";